import React from 'react';
import styles from './HandDisplay.module.css';
import Piece from '../Piece/Piece';

import { PieceType, PlayerColor } from '../../../../../../shared/types/game';


interface HandDisplayProps {
  pieces: PieceType[];
  owner: PlayerColor;
  viewingPlayerColor: PlayerColor;
  onPieceClick: (pieceType: PieceType) => void;
  selectedPiece: PieceType | null;
  className?: string;
}

const HandDisplay: React.FC<HandDisplayProps> = ({ pieces, owner, viewingPlayerColor, onPieceClick, selectedPiece, className  }) => {
  const groupedPieces = pieces.reduce((acc, pieceType) => {
    acc[pieceType] = (acc[pieceType] || 0) + 1;
    return acc;
  }, {} as Record<PieceType, number>);

  const pieceOrder: PieceType[] = ['fu', 'kyo', 'kei', 'gin', 'kin', 'kaku', 'hisha'];

  const isOppositeSide = owner !== viewingPlayerColor;

  return (
    <div className={`${styles.handContainer} ${isOppositeSide ? styles.oppositeSide : ''} ${className || ''}`}>
      <div className={styles.piecesWrapper}>
        {pieceOrder.map(type => {
          const count = groupedPieces[type] || 0;
          if (count > 0) {
            const isSelected = selectedPiece === type;

            return (
              <div
                key={type}
                className={`${styles.handPieceItem} ${isSelected ? styles.selectedHandPiece : ''}`}
                onClick={() => onPieceClick(type)}
              >
                <Piece
                  type={type}
                  owner={owner}
                  viewingPlayerColor={viewingPlayerColor}
                />
                {count > 1 && <span className={styles.pieceCount}>{count}</span>}
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default HandDisplay;